import React, { ComponentProps, ReactElement } from 'react';

import { CSSObject } from 'styled-components';

import LoadMoreData from '@adsk/alloy-react-load-more-data';

import useTableSize from '../hooks/useTableSize';
import { Themeable } from '../types';

type LoadMoreDataProps = ComponentProps<typeof LoadMoreData> & Themeable;

const LoadMoreDataRow = ({
  style = {},
  tableSize,
  ...props
}: LoadMoreDataProps): ReactElement => {
  const { cellPadding, rowHeight } = useTableSize(tableSize);
  return (
    <LoadMoreData
      style={{
        padding: cellPadding,
        height: rowHeight,
        ...(style as CSSObject),
      }}
      {...props}
    />
  );
};

LoadMoreDataRow.propTypes = LoadMoreData.propTypes;

export default LoadMoreDataRow;
